let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fPSoZ")).then(() => parcelRequire('j32SQ'));